// extracted by mini-css-extract-plugin
export default {"container":"slugify-text-field_container__HGjHa","truncate-table":"slugify-text-field_truncate-table__uxfMA","table-text-faded":"slugify-text-field_table-text-faded__WCpY7","wrapper":"slugify-text-field_wrapper__gRd6j","slugifyTextField":"slugify-text-field_slugifyTextField__f97ol","generate":"slugify-text-field_generate__IWVg5","clientUrl":"slugify-text-field_clientUrl__4eI3B"};
    if(module.hot) {
      // 1793877086053
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  